export default __webpack_public_path__ + "static/download-play-badge-0b809602fd4c86c3430b5ea7d8fbe25e.svg";